import {Component} from '@angular/core';

@Component({
    selector: 'app-commission-report',
    templateUrl: './commission-report.component.html',
    standalone: false
})
export class CommissionReportComponent {

}
